import { useQuery } from 'react-query';
import { axios, store, removeLoginIfLogedOut, abortController } from '../config/axios-config';
import {defaultQueryConfig} from "../config/query-config";

// Fetch function for Relatório Detalhado (used inside query and imperative calls)
export async function fetchRelatorioDetalhado({ anoSelecionado, codOcupacoes, estadoSelecionado, municipioSelecionado, cursoSelecionado, grauEscolaridadeSelecionado, areaDetalhada = false }) {

    try {
        const { data } = await axios.post(
          "/backend/getRelatorioDetalhado",
          {
            ano: anoSelecionado,
            ocupacoes: codOcupacoes,
            uf: estadoSelecionado,
            municipio: municipioSelecionado,
            curso: cursoSelecionado,
            grauEscolaridade: grauEscolaridadeSelecionado,
            areaDetalhada: areaDetalhada,
          },
          {
            cancelToken: abortController.token,
          },
        );

        console.log("fetchRelatorioDetalhado", data);
        store.dispatch({ type: 'SET_RELATORIO_DETALHADO', list: data });

        return data;
    } catch (error) {
        console.error("relatorioDetalhado error", error);
    }
}

// Hook for automatically fetching Relatório Detalhado in a React component
export default function useRelatorioDetalhado(params) {
    return useQuery(
        ['relatorioDetalhado', params],
        () => fetchRelatorioDetalhado(params),
        defaultQueryConfig
    );
}
